export default {
  getDetail: "/wechat/evaluation/details", //根据评价id获取评价详情
  getUpdata: "/wechat/evaluation", //小程序评价数据更新
  getInfo: "/wechat/evaluation", //获取优化师信息
  getDictionaryApi: "/wechat/evaluation" //根据type获取数据字典
};
